/** One end of the range: its label, a date button that aims the calendar, and a time field. */
import type { DateTimePoint, RangeEnd } from './date-time-range';
import { DateButton } from './DateButton';
import { fieldLabelStyle } from './picker-styles';
import { TimeField } from './TimeField';

export interface RangeEndFieldsProps {
  which: RangeEnd;
  point: DateTimePoint;
  active: boolean;
  invalid: boolean;
  onAim: () => void;
  onTime: (minutes: number) => void;
}

export function RangeEndFields({
  which,
  point,
  active,
  invalid,
  onAim,
  onTime,
}: RangeEndFieldsProps) {
  const label = which === 'start' ? 'Starts' : 'Ends';
  const noun = which === 'start' ? 'Start' : 'End';
  return (
    <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
      <span aria-hidden="true" style={fieldLabelStyle}>
        {label}
      </span>
      <div style={{ display: 'flex', gap: 8 }}>
        <DateButton
          label={`${noun} date`}
          value={point.date}
          active={active}
          invalid={invalid}
          onClick={onAim}
        />
        <TimeField
          label={`${noun} time`}
          value={point.minutes}
          invalid={invalid}
          onChange={onTime}
        />
      </div>
    </div>
  );
}
